"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.FlightOverviewColumn = void 0;
const classnames_1 = __importDefault(require("classnames"));
const moment_1 = __importDefault(require("moment"));
const react_1 = __importDefault(require("react"));
const dateTimeFormat_1 = require("../../../utils/dateTimeFormat");
const FlightOverviewFlightCard_1 = require("../FlightOverviewFlightCard");
require("./index.scss");
const className = 'flight-overview-column';
const FlightOverviewColumn = (props) => {
    const { className: propsClassName, data, minDesktopCard } = props;
    const classNames = (0, classnames_1.default)(className, propsClassName !== null && propsClassName !== void 0 ? propsClassName : '');
    const date = data.date ? moment_1.default.parseZone(data.date).format(dateTimeFormat_1.DATE_FORMAT) : '';
    return (react_1.default.createElement("div", { className: classNames },
        react_1.default.createElement("div", { className: `${className}__header` },
            react_1.default.createElement("h4", { className: `${className}__title` }, data.title),
            react_1.default.createElement("p", { className: `${className}__date` }, date)),
        react_1.default.createElement("div", { className: `${className}__flight-list` }, data.items.map(flight => (react_1.default.createElement(FlightOverviewFlightCard_1.FlightOverviewFlightCard, { className: `${className}__flight`, key: flight.value.id, flight: flight, withDate: data.withDate, minDesktop: !!minDesktopCard }))))));
};
exports.FlightOverviewColumn = FlightOverviewColumn;
//# sourceMappingURL=index.js.map